/**
 * Objects API. Recent objects (MRU) and related HTTP calls.
 * Used by slices via createAsyncThunk; uses ENDPOINTS and getApiClient.
 */
import { getIfsApiClient } from "./client";
import { ENDPOINTS } from "../configs/endpoints";
import AuthTeams from "../../auth/AuthTeams";
import { logger } from "../../utils/logger";

export const objectsAPI = {
  /**
   * Get recently used objects list.
   * @returns {Promise<{ data: any, timestamp: number }>}
   */
  async getRecentlyUsedList() {
    logger.info("getRecentlyUsedList", null, "API");
    try {
      const serviceClient = getIfsApiClient();
      const webUser = new AuthTeams().getEmail();
      const url = `${ENDPOINTS.OBJECTS.RECENT()}?webUser=${encodeURIComponent(webUser)}`;
      const response = await serviceClient.get(url);
      if (response.status === 200 || response.status === 201) {
        return { data: response.data, timestamp: Date.now() };
      }
      logger.error("getRecentlyUsedList unexpected status", { status: response.status }, "API");
      throw new Error("Unexpected response");
    } catch (err) {
      logger.error("getRecentlyUsedList failed", err, "API");
      throw err;
    }
  },
};
